






















































import Vue from 'vue';
import Component from 'vue-class-component';
import { AxiosError } from 'axios';
import Heading from '../components/Heading.vue';
import Errors from '../components/Errors.vue';
import mostUsedPasswords from '../helpers/mostUsedPasswords';
import { PasswordResetCredentials } from '../store/authStore.d';
import retrieveErrorsFromResponse from '../helpers/retrieveErrorsFromResponse';

const passwordResetCredentials: PasswordResetCredentials = {
  email: '',
  password: '',
  password_confirmation: '', // eslint-disable-line @typescript-eslint/camelcase
  token: '',
};

@Component({
  name: 'PasswordReset',

  components: {
    Heading,
    Errors,
  },
})
export default class PasswordReset extends Vue {
  formInput = passwordResetCredentials;

  errors: Array<string> = [];

  get resetPasswordLoadingState() {
    return this.$store.getters.resetPasswordLoadingState;
  }

  mounted() {
    const { currentRoute } = this.$router;
    const { query, params } = currentRoute;

    if (
      !query.email
      || typeof query.email !== 'string'
      || typeof params.token !== 'string'
    ) {
      this.$router.push({ name: '404' });
      return;
    }

    this.formInput.email = query.email;
    this.formInput.token = params.token;
  }

  changePassword() {
    this.errors = [];

    if (!this.validate()) {
      return;
    }

    this.$store.dispatch('resetPassword', this.formInput)
      .then(() => {
        this.$store.commit('setFlashMessage', [
          'We hebben je wachtwoord gewijzigd, je kan nu inloggen.',
          'success',
        ]);

        this.$router.push({ name: 'Login' });
      })
      .catch((err: AxiosError) => {
        // eslint-disable-next-line no-console
        console.error(err);

        if (!err.response) {
          return;
        }

        this.errors = retrieveErrorsFromResponse(err.response);
      });
  }

  validate() {
    if (!this.formInput.password) {
      this.errors.push('Voer een wachtwoord in');
    }

    if (!this.formInput.password_confirmation) {
      this.errors.push('Voer beide wachtwoord velden in');
    }

    if (this.formInput.password_confirmation !== this.formInput.password) {
      this.errors.push('Beide wachtwoorden moeten overeen komen');
    }

    if (mostUsedPasswords.indexOf(this.formInput.password) >= 0) {
      this.errors.push('Dit wachtwoord is onveilig, gebruik een ander wachtwoord');
    }

    return this.errors.length === 0;
  }
}
